export default "__VITE_ASSET__Csa_nNI___"